module.exports = __webpack_public_path__ + "90595896067c8dca8953210ba731be3e.svg";